import {
  SDK,
  CredentialFactory,
  ImpersonateCredentials,
  type RefreshableJwt
} from '@tickethead/sdk';
import { parseJwt } from '../utils/utils';

const sdkStateKey = 'impersonated_by_sdk';

export default ($sdk: SDK) => ({
  async identifyWallet(secret, tenant) {
    if ($sdk.tenant !== tenant) {
      $sdk.tenant = tenant;
    }
    return (
      await $sdk.tenantClient.post(`/websocket/v1/adhoc`, {
        secret
      })
    ).data;
  },
  async stopImpersonate() {
    const sdkState = localStorage.getItem(sdkStateKey);
    localStorage.removeItem(sdkStateKey);

    if (!sdkState) {
      $sdk.logout();
      throw new Error('Trying to stop impersonation when there is no token');
    }

    // Restore the state of the SDK to the one before the impersonation
    // We cant just call the build method, as we need the event listeners defined in axios.ts
    const savedSdkState = JSON.parse(sdkState);
    const credentials = CredentialFactory.build(savedSdkState.credentials);

    await $sdk.authorize(credentials);
    await $sdk.useOrganizer(savedSdkState.organizer);

    const tokenInfo = parseJwt($sdk.getToken().token);
    const userData = await $sdk.account.getUser({ id: tokenInfo.id });
    return {
      ...tokenInfo,
      ...userData
    };
  },

  async impersonate(userId: number, organizerId: string) {
    // Save the current state of the SDK
    localStorage.setItem(sdkStateKey, JSON.stringify($sdk.serialize()));

    // Update the credentials
    const impersonateCredentials = new ImpersonateCredentials(
      $sdk.getToken() as RefreshableJwt,
      userId
    );
    await $sdk.authorize(impersonateCredentials, organizerId);

    const tokenInfo = parseJwt($sdk.getToken().token);
    const userData = await $sdk.account.getUser({
      id: tokenInfo.id
    });
    return {
      ...tokenInfo,
      ...userData
    };
  }
});
